import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import type { ReactElement } from 'react';
import React, { useState } from 'react';
import type { TableInstance } from 'react-table';

import styles from './Table.scss';
import SearchIcon from './assets/search.svg';

interface Props<T extends object> {
  instance: TableInstance<T>;
  searchBy: string;
}

const SearchBy = <T extends object>({ instance, searchBy }: Props<T>): ReactElement => {
  const [filterInput, setFilterInput] = useState<string>('');
  const { setFilter } = instance;
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value || undefined;
    setFilterInput(value ?? '');
    setFilter(searchBy, value);
  };

  return (
    <TextField
      classes={{ root: styles.search }}
      value={filterInput}
      onChange={handleFilterChange}
      placeholder="Search by name"
      InputProps={{
        disableUnderline: true,
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon width="24" height="24" stroke="white" />
          </InputAdornment>
        )
      }}
    />
  );
};

export default SearchBy;
